export const environmentData = {
  run: "development",
  development: {
    clientId: "22ca69bd-81d1-4a65-916c-139cfbbc396b",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 22ca69bd-81d1-4a65-916c-139cfbbc396b/User.Impersonation",

    apiBaseURL: "https://hm-zalora-dashboard-v8.azurewebsites.net/api"
  },
  staging: {
    clientId: "22ca69bd-81d1-4a65-916c-139cfbbc396b",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 22ca69bd-81d1-4a65-916c-139cfbbc396b/User.Impersonation",

    apiBaseURL: "https://hm-zalora-dashboard-v8.azurewebsites.net/api"
  },
  production: {
    clientId: "22ca69bd-81d1-4a65-916c-139cfbbc396b",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 22ca69bd-81d1-4a65-916c-139cfbbc396b/User.Impersonation",
    apiBaseURL: "https://hm-zalora-dashboard-v8.azurewebsites.net/api"
  },
};
